import { UnitsManagementConst } from '@featureModule/units-management/consts';

/**
 * Unit Types constant
 */
const UNIT_TYPES_CONST = UnitsManagementConst.CHILDREN.UNIT_TYPES;

/**
 * Translate key mapper for the Unit Types list component.
 */
export const UnitTypesListTranslateMapper = {

    TITLE: () => {
        return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.TITLE`;
    },

    MENU_LABEL: () => {
        return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.MENU_LABEL`;
    },

    DESCRIPTION: () => {
        return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DESCRIPTION`;
    },

    DATA_TABLE: {
        COLUMNS: {
            NAME: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DATA_TABLE.COLUMNS.NAME`;
            },
            DESCRIPTION: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DATA_TABLE.COLUMNS.DESCRIPTION`;
            },
            LEVEL: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DATA_TABLE.COLUMNS.LEVEL`;
            },
            DEFAULT_TYPE_FOR_ITS_LEVEL: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DATA_TABLE.COLUMNS.DEFAULT_TYPE_FOR_ITS_LEVEL`;
            },
            ICON: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DATA_TABLE.COLUMNS.ICON`;
            },
            CREATED_ON: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DATA_TABLE.COLUMNS.CREATED_ON`;
            },
            ACTIONS: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.DATA_TABLE.COLUMNS.ACTIONS`;
            },
        },
    },

    FORM: {

        ADD_UNIT_TYPE: () => {
            return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.ADD_UNIT_TYPE`;
        },

        EDIT_UNIT_TYPE: () => {
            return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.EDIT_UNIT_TYPE`;
        },

        DELETE_UNIT_TYPE: () => {
            return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.DELETE_UNIT_TYPE`;
        },

        DELETE_CONFIRM: () => {
            return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.DELETE_CONFIRM`;
        },

        NAME: {
            LABEL: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.NAME.LABEL`;
            },
            PLACEHOLDER: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.NAME.PLACEHOLDER`;
            },
        },

        DESCRIPTION: {
            LABEL: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.DESCRIPTION.LABEL`;
            },
            PLACEHOLDER: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.DESCRIPTION.PLACEHOLDER`;
            },
        },

        LEVEL: {
            LABEL: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.LEVEL.LABEL`;
            },
            PLACEHOLDER: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.LEVEL.PLACEHOLDER`;
            },
        },

        ICON: {
            LABEL: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.ICON.LABEL`;
            },
            PLACEHOLDER: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.ICON.PLACEHOLDER`;
            },
        },

        DEFAULT_TYPE_FOR_ITS_LEVEL: {
            LABEL: () => {
                return `${UNIT_TYPES_CONST.TRANSLATE_KEY()}.FORM.DEFAULT_TYPE_FOR_ITS_LEVEL.LABEL`;
            },
        },

    },

};
